import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ccac-range',
  templateUrl: './ccac-range.component.html',
  standalone: false
})
export class CCACRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
